import { useMutation } from '@apollo/client';
import { graphql } from 'gql.tada';

const UpdateCourseMutation = graphql.persisted(
  "UpdateCourse",
  graphql(`
    mutation UpdateCourse($input: UpdateCourseInput!) {
      updateCourse(input: $input) {
        course {
          id
          name
          slug
        }
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export { UpdateCourseMutation };

export function useUpdateCourse() {
  return useMutation(UpdateCourseMutation);
}
